import getObjectKey from 'lib/object/getObjectKey'
import { omitKeys } from 'lib/object/objectUtils'

/**
 * @returns formatted points key e.g. "price:100;productType:hotel;offerId:123;packageId:456"
 * itemId and nights are excluded:
 * - itemId: to not retrigger the points calculation request at checkout
 * - nights: display-only metadata that doesn't affect the calculation
 */
function buildPointsKey(
  calculationRequest: App.LoyaltyPointsEarnCalculationRequest,
  customerId: string,
): string {
  return getObjectKey({
    ...(omitKeys(['itemId', 'nights'], calculationRequest)),
    customerId,
  })
}

export default buildPointsKey
